import { isWeixin } from './index.js'
import Cookie from 'js-cookie'
import { COOKIE_KEY, AUTH_URL, COOKIE_KEY_PRXFIX } from './constant'

function buildQueryString (obj) {
  let arr = []
  for (let key in obj) {
    arr.push(`${key}=${obj[key]}`)
  }
  return arr.join('&')
}

export function jumpToAuthPath (toPath) {
  if (!toPath) {
    toPath = window.location.href
  }
  console.log('redirect to Auth Page')
  // 一般情况下，将目标页面的路径拼接到url 后面，后台从 queryString拿。
  // 特殊情况可以修改这个逻辑，直接从referer拿也行
  let config = {
    scope: 'snsapi_base',
    appid: 'wx6961bc0d34055450',
    componentid: 'wxffb507d905139a33',
    loginurl: 'https://mpauth.wecity.qq.com/a/mpauth',
    proxyServer: '',
    thloginCookieKey: COOKIE_KEY_PRXFIX,
    thCallbackUrl: encodeURIComponent(toPath)
  }
  const redirectURI = `${config.loginurl}?userinfo=${0}&componentid=${config.componentid}&callback=${config.thCallbackUrl}`
  const openAuth = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appid}&redirect_uri=${encodeURIComponent(redirectURI)}&response_type=code&scope=${config.scope}&component_appid=${config.componentid}#wechat_redirect`
  window.location.href = openAuth
  return new Promise(resolve => { // 确保页面完成跳转，不会切换路由的时候发生跳转
    setTimeout(resolve, 1e4)
  })
}

/**
 * @description 该函数用于wx环境下在beforeRouter阶段进行校验和授权，调用时若没有鉴权则自动进行重定向鉴权
 * @param {String} toPath 自动重定向授权时，授权回调的完整url，默认为window.location.href
 * @param {Number} level 强制等级 0:仅验证cookies 1:同时验证session
 * @param {Boolean} autoRedirect 是否,自动重定向授权
 * @returns {Boolean} 是否是鉴权状态
 */
export async function wxLogin ({ toPath, level = 0, autoRedirect = true } = {}) {
  if (!isWeixin()) {
    return false
  }
  if (self !== top) {
    return false
  }
  // step 1 Check cookies
  if (!(Cookie.get(COOKIE_KEY))) {
    // Cookies 不存在，强制跳转
    if (autoRedirect) {
      await jumpToAuthPath(toPath)
    }
    return false
  }
  // step 2 Check Session
  if (level === 1) {
    // TODO 拉取接口，确认当前的session状态

  }

  // step 3 Confirm
  return true
}
